import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import { preloadVoices } from './lib/speech';

// 音声リストを事前ロード（初回のWebSpeech遅延回避）
preloadVoices();
window.speechSynthesis?.addEventListener?.('voiceschanged', preloadVoices);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
